import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import { AddSubscriber } from 'app/components/icons'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { SUBMIT } from 'app/constants/button'

const ReInvited = (props) => {
  const { closeMenu, onAction } = props

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <>
      <MenuItem onClick={() => handleOpen()} className="space-x-5">
        <AddSubscriber classes="w-auto" />
        <Typography className="text-14 font-400 text-primary">
          {formatMessage({
            id: 'teamMembers.lable.reInvite',
          })}
        </Typography>
      </MenuItem>
      <SubmitDialog
        id="dialog-re-invite-team-member"
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'teamMembers.reInvite.title',
        })}
        description={formatMessage({
          id: 'teamMembers.reInvite.description',
        })}
        submitText={formatMessage({
          id: 'teamMembers.lable.reInvite',
        })}
        onSubmit={async () => {
          await onAction()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

ReInvited.propTypes = {
  onAction: PropTypes.func,
  closeMenu: PropTypes.func,
}

export default ReInvited
